module.exports = __webpack_public_path__ + "static/media/Neck_tail.36561451.png";